import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validateOrgSearch: Validator = (data: SearchContextType) => {
  const {
    organisationName,
    organisationPostCode,
    organisationHouseNumber,
    organisationGmcNumber,
    firstName,
    middleNames,
    lastName,
    dateOfBirth,
  } = data;

  const hasOrganisationName = !!organisationName?.trim();
  const hasAtLeastOneOther =
    !!organisationPostCode?.trim() ||
    !!organisationHouseNumber?.trim() ||
    !!organisationGmcNumber?.trim();

  const hasAnyOtherValue =
    !!firstName?.trim() ||
    !!middleNames?.trim() ||
    !!lastName?.trim() ||
    !!dateOfBirth?.toString().trim();

  const isOrgOnlySearch =
    hasOrganisationName && hasAtLeastOneOther && !hasAnyOtherValue;

  if (!hasOrganisationName && !hasAtLeastOneOther) {
    return { isValid: false, errors: [] };
  }

  if (!hasOrganisationName || !hasAtLeastOneOther) {
    return {
      isValid: false,
      errors: [ValidationErrorMessages.invalidOrganisation],
    };
  }

  return isOrgOnlySearch
    ? { isValid: true, errors: [] }
    : { isValid: false, errors: [ValidationErrorMessages.invalidOrganisation] };
};

export default validateOrgSearch;
